<script setup lang="ts">
import CheckboxToggle from "@/components/form/CheckboxToggle.vue"
import type { ChampionshipRegistrationSelectTeamTask } from "@/model/championship/championship-registration-select-team-task"
import type { TasksProps } from "@/pages/Tasks/Tasks/tasks-props"
import { useHttpClient, useHttpGet } from "@/vf"
import { toRefs } from "vue"
import ChampionshipRegistrationResetButton from "./ChampionshipRegistrationResetButton.vue"
import ChampionshipRegistrationTeamList from "./ChampionshipRegistrationTeamList.vue"
import type { ChampionshipRegistrationApproveData } from "./championship-registration"

const props = defineProps<TasksProps<ChampionshipRegistrationSelectTeamTask>>()

const emit = defineEmits<{
    (e: "updated"): void
}>()

const { task } = toRefs(props)
const { data } = await useHttpGet<ChampionshipRegistrationApproveData>(
    `/championship/registration/${task.value.organizationId}/select-payment-method/${task.value.id}`,
)
const http = useHttpClient()

/*─────────────────────────────────────┐
│  submit                              │
└─────────────────────────────────────*/
async function submit() {
    await http.post(`/championship/registration/${data.value!.registrationId}/select-payment-method`)
    emit("updated")
}
</script>
<template>
    <div class="p-5" v-if="props.viewMode === 'admin'">
        <div class="alert alert-info">
            {{ $t("@tasks:tasks.championship_registration.select_payment_method.waiting_for_customer") }}
        </div>

        <ChampionshipRegistrationTeamList :teams="data!.teams" :view-mode="props.viewMode" />
    </div>
    <div class="p-5" v-else>
        <b>{{ $t("@tasks:tasks.championship_registration.select_payment_method.description.title") }}</b>
        <div>{{ $t("@tasks:tasks.championship_registration.select_payment_method.description.text") }}</div>

        <div class="pl-3 mb-5 mt-4">
            <CheckboxToggle>Auswahl von Mollie</CheckboxToggle>
            <CheckboxToggle>Teammitglieder sollen Zahlungsaufforderung erhalten</CheckboxToggle>
        </div>

        <ChampionshipRegistrationTeamList :teams="data!.teams" :view-mode="props.viewMode" />

        <div class="d-flex justify-content-between mt-5">
            <div class="flex-grow-1">
                <ChampionshipRegistrationResetButton
                    :registrationId="data!.registrationId"
                    @resetted="emit('updated')"
                />
            </div>
            <div>
                <button class="btn btn-primary" @click="submit()">Jetzt bezahlen</button>
            </div>
        </div>
    </div>
</template>
